/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState, useCallback } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";
import getCroppedImg from "../../utils/cropImage";
import { CropperWrapper } from "../../utils/CropperWrapper";
import ImageUploader from "../../utils/ImageUploader";

// AD3 — KD46200WHITE BABY
// Pozycje tekstów (style inline, w mm):
//   top   = górna krawędź pola tekstowego
//   left  = środek tekstu (textAlign center + translateX(-50%)) albo lewa krawędź (textAlign left)
//   right = prawa krawędź pola (textAlign right)
// maxWidthN = maks. szerokość tekstu w px — dłuższy tekst zmniejsza czcionkę.
// Uwaga: lineHeight w stylu InlineEdit nie działa (nadpisuje go `font: inherit`), zawsze wynosi 1.5.
export const Ad3: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("ALBUM");
  const [text2, setText2] = useState<string>("Kacperka");
  const [text3, setText3] = useState<string>("Godz. 13:33");
  const [text4, setText4] = useState<string>("39 cm");
  const [text5, setText5] = useState<string>("4500 g");
  const [text6, setText6] = useState<string>("31.03.2023 r.");
  const text1BasicSize = 34;
  const text2BasicSize = 77;
  const text3BasicSize = 21;
  const text4BasicSize = 25;
  const text5BasicSize = 28;
  const text6BasicSize = 41;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const [fontSizeText5, setFontSizeText5] = useState<number>(text5BasicSize);
  const [fontSizeText6, setFontSizeText6] = useState<number>(text6BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();
  const [image, setImage] = useState<string | null>(null);
  const [croppedImage, setCroppedImage] = useState<string | null>(null);
  const [crop, setCrop] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
  const [zoom, setZoom] = useState<number>(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);
  const [step, setStep] = useState<"select" | "crop" | "view">("select");

  const pdfWidth = "215mm"; // PDF width in mm
  const pdfHeight = "223mm"; // PDF height in mm
  const font1 = "Drogowskaz";
  const font2 = "HandycheeraRegular";
  const font3 = "Caveatbrush";
  const maxWidth1 = 192;
  const maxWidth2 = 373;
  const maxWidth3 = 152;
  const maxWidth4 = 129;
  const maxWidth5 = 142;
  const maxWidth6 = 258;
  // Okno na zdjęcie użytkownika
  const photoTop = "70.9mm";
  const photoLeft = "60.4mm";
  const photoWidth = "93.3mm";
  const photoHeight = "93.3mm";
  const photoAspect = 93.3 / 93.3;

  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number,
    fontFamily: string,
    maxWidth: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px ${fontFamily}`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px ${fontFamily}`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  // Czekamy na załadowanie fontu, inaczej canvas mierzy tekst fontem zastępczym.
  const ensureFont = (fontFamily: string) => document.fonts.load(`1em ${fontFamily}`);

  useEffect(() => {
    ensureFont(font1).then(() =>
      setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10, font1, maxWidth1))
    );
  }, [text1]);
  useEffect(() => {
    ensureFont(font2).then(() =>
      setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 14, font2, maxWidth2))
    );
  }, [text2]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10, font3, maxWidth3))
    );
  }, [text3]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10, font3, maxWidth4))
    );
  }, [text4]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText5(adjustFontSize(text5, fontSizeText5, text5BasicSize, 10, font3, maxWidth5))
    );
  }, [text5]);
  useEffect(() => {
    ensureFont(font3).then(() =>
      setFontSizeText6(adjustFontSize(text6, fontSizeText6, text6BasicSize, 14, font3, maxWidth6))
    );
  }, [text6]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth,
        pdfHeight: pdfHeight,
        pdfNameFromUrl: pdfNameFromUrl,
      },
      croppedImage,
      true
    );
  };

  const handleCropComplete = useCallback((croppedArea: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const handleShowCroppedImage = useCallback(async () => {
    if (image && croppedAreaPixels) {
      const croppedImg = await getCroppedImg(image, croppedAreaPixels);
      setCroppedImage(croppedImg);
      setStep("view");
    }
  }, [image, croppedAreaPixels]);

  return (
    <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />
      <div style={{ position: "absolute", top: "10px", left: "0px", right: "0px", margin: "auto", color: "white", width: "480px", maxWidth: "100%", height: "70px", gap: "30px", display: "flex", alignItems: "center" }}>
        <ImageUploader
          onImageChange={(image) => setImage(image)}
          setStep={setStep}
        />
        {step === "crop" && (
          <p>
            Aby wykadrować zdjęcie możesz kręcić kółkiem myszy i przesuwać obraz
          </p>
        )}
        <div style={{}}>
          {step !== "crop" && (
            <Button onClick={handleSave} disabled={isSaving}>
              {isSaving ? "Zapisywanie..." : "Zapisz"}
            </Button>
          )}
          {step === "crop" && (
            <Button onClick={handleShowCroppedImage}>Zakończ kadrowanie</Button>
          )}
        </div>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Drogowskaz, HandycheeraRegular, Caveatbrush",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        {/* ALBUM */}
        <InlineEdit
          value={text1}
          setValue={setText1}
          style={{
            fontSize: `${fontSizeText1}px`,
            fontFamily: font1,
            color: "#af6b47",
            position: "absolute",
            top: "15.9mm",
            left: "107.6mm",
            width: `${maxWidth1 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Kacperka */}
        <InlineEdit
          value={text2}
          setValue={setText2}
          style={{
            fontSize: `${fontSizeText2}px`,
            fontFamily: font2,
            color: "#cda183",
            position: "absolute",
            top: "25.3mm",
            left: "106.8mm",
            width: `${maxWidth2 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* Godz. 13:33 */}
        <InlineEdit
          value={text3}
          setValue={setText3}
          style={{
            fontSize: `${fontSizeText3}px`,
            fontFamily: font3,
            color: "#928980",
            position: "absolute",
            top: "52mm",
            left: "169.2mm",
            width: `${maxWidth3 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            letterSpacing: "-0.4px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 39 cm */}
        <InlineEdit
          value={text4}
          setValue={setText4}
          style={{
            fontSize: `${fontSizeText4}px`,
            fontFamily: font3,
            color: "#928980",
            position: "absolute",
            top: "76.9mm",
            left: "187.2mm",
            width: `${maxWidth4 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 4500 g */}
        <InlineEdit
          value={text5}
          setValue={setText5}
          style={{
            fontSize: `${fontSizeText5}px`,
            fontFamily: font3,
            color: "#928980",
            position: "absolute",
            top: "106mm",
            left: "176.6mm",
            width: `${maxWidth5 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />
        {/* 31.03.2023 r. */}
        <InlineEdit
          value={text6}
          setValue={setText6}
          style={{
            fontSize: `${fontSizeText6}px`,
            fontFamily: font3,
            color: "#928980",
            position: "absolute",
            top: "177.2mm",
            left: "156.3mm",
            width: `${maxWidth6 + 10}px`,
            transform: "translateX(-50%)",
            textAlign: "center",
            paddingLeft: "5px",
            fontWeight: "400",
            zIndex: "12",
          }}
        />

        {/* Step: Crop */}
        {image && step === "crop" && (
          <CropperWrapper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={photoAspect}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={handleCropComplete}
            style={{
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              transform: "none",
            }}
          />
        )}

        {/* Step: View */}
        {croppedImage && step === "view" && (
          <img
            src={croppedImage}
            alt=""
            style={{
              position: "absolute",
              top: photoTop,
              left: photoLeft,
              width: photoWidth,
              height: photoHeight,
              objectFit: "cover",
              zIndex: 6,
            }}
          />
        )}

        <img
          src="/images/AD3.svg"
          alt=""
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0', zIndex: '2' }}
        />
      </div>
    </div>
  );
};
